import React from 'react'
// import { EMPTY_ARRAY } from '../../constants/globalConstants'
import GooglePayDC from './GooglePayDC'
import ApplePayDataCap from './ApplePayDataCap'
import DatatransWallet from './DatatransWallet'
import GooglePayHL from './GooglePayHL'
import ApplePayHL from './ApplePayHL'
import './applepayreset.scss'
// import { Circles } from 'react-loader-spinner'

const renderWalletButtons = (props) => {
    const{ faciltyData, getValues, onSubmit, setIsSubmittingForm, isIOSDevice, applePaySessionRef, isSubmittingForm, extend, dispatch, paybyCard } = props
    // const [paymentGateWay, setPaymentGateyway] = useState(null)
    // const loaded = useRef(false)
    
    // useEffect(() => {
    //     const paymentGateway = faciltyData?.facility?.facility_payment_details?.facility_payment_type_id
    //     setPaymentGateyway(paymentGateway)
    // },[EMPTY_ARRAY, faciltyData?.full_name])
    return(
        <>
            {isSubmittingForm ? null : paybyCard ? <div className={`${extend ? 'mb-2' : 'my-2'} d-flex mx-4 align-items-center justify-content-center`}>
                <div className='bg-grey w-100' style={{height:'2px'}}></div>
                <div className=' p-2 bg-white text-center font-weight-bold text-black'>OR</div> 
                <div className='bg-grey w-100' style={{height:'2px'}}></div>
            </div> : null}
            {isSubmittingForm ? null
            // <div className='container'>
            //     <div className=' d-flex justify-content-center p-2 border-grey border border-2 border-primary border-opacity-50 rounded'>
            //     <p className='mb-0'>Please wait...</p> <span className='ms-2'><Circles
            //             height="20"
            //             width="20"
            //             color='text-primary'
            //             style={{ display: 'inline-block' }}
            //             ariaLabel="circles-loading"
            //             visible={true}
            //         />
            //         </span>
            //     </div>
            // </div> 
            : <>
                {faciltyData?.facility?.facility_payment_details?.facility_payment_type_id == 1 ? <>
                    {(faciltyData?.facility?.facility_payment_details?.data_trans_username_web && faciltyData?.facility?.facility_payment_details?.data_trans_merchant_name && faciltyData?.facility?.facility_payment_details?.data_trans_gpay_merchant) ? <DatatransWallet faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm}/> : null}
                </> : faciltyData?.facility?.facility_payment_details?.facility_payment_type_id == 2 ? <>
                    {(faciltyData?.facility?.facility_payment_details?.wallet_datacap_token && faciltyData?.facility?.facility_payment_details?.wallet_datacap_mid && faciltyData?.facility?.facility_payment_details?.wallet_datacap_gpay_merchant) ? <> {isIOSDevice ? 
                        <ApplePayDataCap faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} dispatch={dispatch} />
                        : <GooglePayDC faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} dispatch={dispatch} />}
                    </> : null}
                </> : faciltyData?.facility?.facility_payment_details?.facility_payment_type_id == 4 ? <>
                    { isIOSDevice ? faciltyData?.facility?.facility_payment_details?.heartland_merchant_id ? <ApplePayHL faciltyData={faciltyData} getValues={getValues} setIsSubmittingForm={setIsSubmittingForm} isSubmittingForm={isSubmittingForm} onSubmit={onSubmit} applePaySessionRef={applePaySessionRef} /> : null
                    : faciltyData?.facility?.facility_payment_details?.heartland_merchant_id ? <GooglePayHL faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} isSubmittingForm={isSubmittingForm} /> : null}
                </> : null}
            </>}
        </>
    )

}
export default renderWalletButtons